import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import {  Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { addToCart } from '../ShoppingCart/addToCart';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import LoadSpinner from '../Utilities/LoadSpinner';


interface Params extends Record<string, string | undefined> {
  id: string | undefined;
}

interface CampSiteDetailsProps {
  dateRange: { startDate: Date | null; endDate: Date | null };
  cartItems: any[];
  setCartItems: (items: any[]) => void;
}

const CampSiteDetails: React.FC<CampSiteDetailsProps> = ({ dateRange, cartItems, setCartItems }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams<Params>();
  const [campsite, setCampsite] = useState<any | null>(null);

  useEffect(() => {
    const fetchCampsiteDetails = async () => {
      try {
        console.log(`Fetching details for campsite ID: ${id}`);
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/Campsite/getCampSite/${id}`);
        console.log('Response data:', response.data);
        setCampsite(response.data);
      } catch (error) {
        console.error('Error fetching campsite details', error);
      }
    };

    fetchCampsiteDetails();
  }, [id]);

  useEffect(() => {
    console.log('Campsite state updated:', campsite);
  }, [campsite]);

  const handleBack = () => {
    console.log('Location state:', location.state);
    if (location.state && location.state.dateRange) {
      navigate("/booking", { state: { dateRange: location.state.dateRange } });
    } else {
      console.error("dateRange is null or undefined");
      navigate("/booking", { state: { dateRange: null } });
    }
  };

  const handleAddToCart = async () => {
    if (!id) return;

    const startDateUTC = dateRange.startDate ? new Date(dateRange.startDate.getTime() - dateRange.startDate.getTimezoneOffset() * 60000).toISOString() : '';
    const endDateUTC = dateRange.endDate ? new Date(dateRange.endDate.getTime() - dateRange.endDate.getTimezoneOffset() * 60000).toISOString() : '';

    try {
      const updatedCart = await addToCart(Number(id), startDateUTC, endDateUTC);
      if (updatedCart) {
        console.log('Item added to cart:', updatedCart);
        setCartItems(updatedCart.data.items);
      }
    } catch (error) {
      console.error('Error adding item to cart', error);
    }
  };

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(amount);
  };

  if (!campsite) {
    return (
      <div className="container d-flex justify-content-center align-items-center vh-100">
        <LoadSpinner />
      </div>
    );
  }

  return (
    <>
      <div className="container d-flex justify-content-center">
        <div className='camp-details'>
          <div className='d-flex justify-content-center pt-2 pb-2'>
            <button className="back-button" onClick={handleBack}>
              <FontAwesomeIcon icon={faArrowCircleLeft} className="icon"/> Back To Campsite List
            </button>
          </div>
          <div className="text-center pt-2">
            <h1>{campsite.name}</h1>
            <Carousel interval={2000} pause={false}>
              {campsite.imageUrls.map((image: any, index: number) => (
                <Carousel.Item key={index}>
                  <img
                    src={image.url}
                    className="campsite-image"
                    alt={`Campsite ${index + 1}`}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
          <div className='camp-description'>
            <div className='pt-2'>Location: {campsite.location}</div>
            <div>Capacity: {campsite.capacity}</div>
            <div>Price per night: {formatCurrency(campsite.pricePerNight)}</div>
            <div>{campsite.description}</div>
            <div className='pt-2 mb-5 pb-5'>
              <button className="basket-button" onClick={handleAddToCart}>
                <FontAwesomeIcon icon={faShoppingCart} className='icon' /> Add to Cart
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CampSiteDetails;